import { create } from "zustand";
import axios from "../helper/axios";

const useSkillMatrixStore = create((set, get) => ({
  isModalOpen: false,

  setModalOpen: () => {
    set({ isModalOpen: true });
  },

  handleModalOk: () => set({ isModalOpen: false }),
  handleModalCancel: () => set({ isModalOpen: false }),

  handleSkillAdd: async (value, jdID) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));

      await axios.post(`/addskillmatrix/${userData.qhoid}/${jdID}`, {
        ...value,
      });

      // Optional: Close modal on success
      set({ isModalOpen: false });
    } catch (err) {
      console.error("Error adding skill:", err);
    }
  },

  handleSkillUpdate: async (value, jdID) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));

      await axios.put(`/updateskillmatrix/${userData.qhoid}/${jdID}`, [
        ...value,
      ]);
    } catch (err) {
      console.error("Error updating skill:", err);
    }
  },
  handleRemoveSkill: async (skillsToDelete, jdID) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));

      await axios.delete(`/deleteskillmatrix/${userData.qhoid}/${jdID}`, {
        data: skillsToDelete,
      });
    } catch (err) {
      console.error("Error deleting skill:", err);
    }
  },

  handleCandidateSkillUpdate: async (value, jdID, rID) => {
    try {
      console.log("Updating candidate skill matrix with value:",jdID, rID, value);

      const userData = JSON.parse(localStorage.getItem("userDetails"));
      await axios.put(
        `/updateApplicationSkillMatrix/${userData.qhoid}/${userData.qhuid}/jds/${jdID}/${rID}`,
        [...value],
      );
    } catch (err) {
      console.error("Error updating skill:", err);
    }
  },
}));

export default useSkillMatrixStore;
